import React, {useEffect} from "react";
import CacheService from "../../../core/services/cache/cache_service";
import {LoadingView} from "../loading";


export interface AuthenticationLogoutViewProps {
    proceed: boolean;
    navigateToCoreUrl: (mode: 'logout' | 'login') => void;
}

export const AuthenticationLogoutView: React.FC<AuthenticationLogoutViewProps> = ({proceed, navigateToCoreUrl}) => {

    /**
     * if the type is logout, then it calls the logout function
     */
    useEffect(() => {
        if (!proceed) {
            return;
        }
        void CacheService.logout(false);
        navigateToCoreUrl('logout')
    }, [navigateToCoreUrl, proceed]);

    return (
        <LoadingView message={"Thanks for using Operator Platform. See You Soon"}/>
    );
}